<template>
            <div class="feature_style" id="featuresection">    
            <div class="container">
            <div class="row"> 

            <div class="col-lg-12 col-md-12">
            <h1>
                Checkout Our <span class="txt_style"> Software </span> <br> Features Below
            </h1>
            </div>

            <div class="card_style">
            <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 feature">
            <div class="card style">
                <div class="p-5 enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                <div class="icon_box">
                        <img src="assets/Group 1761.png">
                </div>
                </div>

                </div>
                    <div class="row text-center">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum Lorem </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </div>
                    </div>
                </div>
            </div>  
            </div>
                        
            <div class="col-lg-3 col-md-6 col-sm-12 feature">
            <div class="card style">
                <div class="p-5 enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                        <div class="icon_box">
                <div>
                        <img src="assets/Group 1762.png">
                </div>
                </div>
                </div>

                </div>
                    <div class="row text-center">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum Lorem </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </div>
                    </div>
                </div>
            </div>  
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 feature">
            <div class="card style">
                <div class="p-5 enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                    <div class="icon_box">
                <div>
                        <img src="assets/Group 1763.png">
                </div>
                </div>
                </div>

                </div>
                    <div class="row text-center">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum Lorem </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </div>
                    </div>
                </div>
            </div>  
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 feature">
            <div class="card style">
                <div class="p-5 enroll2">
                <div class="row text-center">
                <div class="col-lg-12 ">
                    <div class="icon_box">
                <div>
                        <img src="assets/Group 1764.png">
                </div>
                </div>
                </div>

                </div>
                    <div class="row text-center">
                    <div class="col-lg-12">
                        <h5> Lorem Ipsum Lorem </h5>
                        <p>
                            Description is like something we need for.
                        </p>
                        <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    </div>
                    </div>
                </div>
            </div>  
            </div>

            </div>
            </div>

            </div>

            </div>
            </div>
</template>

<script>
export default {
    name: "Feature"
};
</script>


<style scoped>

.feature_style
{ 
   padding-top: 80px;
   padding-bottom: 80px;
   background-color: whitesmoke;
}


.card_style
{

margin-top: 70px;
border: 5px solid transparent;
padding: 0px;

}

.style
{
    padding: 40px;
    border-radius: 8px;    
}

.icon_box
{
 border: 1px solid transparent;
 border-radius: 8px;
 background-color: #E6FFFC;
 padding: 50px;
 margin-bottom: 50px;
}


.icon_box img 
{
    width: 66px;
    height: 66px;
}

/* .icon_box:hover
{
  transform: translate(1px, 1px);
  box-shadow: 0px 10px 15px -5px rgb(182, 182, 182);
} */

.card:hover
{
  box-shadow: 0px 4px 15px -1px rgb(182, 182, 182);
  border: 1px solid transparent;
  transition-timing-function: ease-in-out;
} 


 i:hover
{
     background-color: #1F4F46;
     color: white;
     padding: 2px;
     border-radius: 35px;
     
}

.txt_style
{

font-weight: bolder;

}


@media (min-width:1200px) and (max-width: 2000px) 
{


}

@media (min-width:992px) and (max-width: 1199px) 
{
.style
{
    padding: 0px !important;
    border-radius: 8px;
    
}


.icon_box[data-v-7f6541f6] {
    border: 1px solid transparent;
    border-radius: 8px;
    background-color: #E6FFFC;
    padding: 0px;
    margin-bottom: 50px;
}


.feature_style {
    margin-top: 0px;
    padding-bottom: 80px;
}


}

@media (min-width:768px) and (max-width: 991px) 
{

.card_style
{
    padding: 10px;
}

.feature
{
   padding: 10px;
}
}

@media (min-width:576px) and (max-width: 767px) 
{


.style 
{
    padding: 40px;
    border-radius: 8px;
    margin-bottom: 15px !important;
}

}


@media (min-width:320px) and (max-width: 575px) 
{

.icon_box
{
    border: 1px solid transparent;
    border-radius: 8px;
    background-color: #E6FFFC;
    padding: 0px !important;
    margin-bottom: 50px;
}

  
}


</style>